import { render, staticRenderFns } from "./reisetermine-card-vorgaenge-optionalsAndExtensions.vue?vue&type=template&id=e8022910&scoped=true"
import script from "./reisetermine-card-vorgaenge-optionalsAndExtensions.vue?vue&type=script&lang=js"
export * from "./reisetermine-card-vorgaenge-optionalsAndExtensions.vue?vue&type=script&lang=js"
import style0 from "./reisetermine-card-vorgaenge-optionalsAndExtensions.vue?vue&type=style&index=0&id=e8022910&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8022910",
  null
  
)

export default component.exports